module.exports = __webpack_public_path__ + "static/media/shoushan_web.1efb4105.png";